<template>
  <AuthLoading v-if="loadStatus === 'LOADING'"></AuthLoading>
  <component
    :is="resolveLayout"
    v-else-if="
      loadStatus === 'SUCCEEDED' ||
      loadStatus === 'FAILED' ||
      loadStatus === 'EXPIRES'
    "
  >
    <keep-alive :include="catchComponents">
      <router-view></router-view>
    </keep-alive>
  </component>
</template>

<script>
import { computed } from 'vue'
import { useRouter } from '@/utils'
import LayoutBlank from '@/layouts/Blank.vue'
import LayoutContent from '@/layouts/Content.vue'
// import useAuthentication from '@/hooks/useAuthentication'
import { useAppStore, useUserStore } from '@/store/app'
import AuthLoading from './components/AuthLoading.vue'

export default {
  components: {
    LayoutBlank,
    LayoutContent,
    AuthLoading,
  },
  setup() {
    const { route } = useRouter()
    const resolveLayout = computed(() => {
      // Handles initial route
      if (route.value.name === null) return null

      if (route.value.meta.layout === 'blank') return 'layout-blank' // 空白布局

      return 'layout-content' // 菜单栏布局
    })

    const store = useAppStore()
    const catchComponents = computed(() => store.catch_components)

    const userStore = useUserStore()

    const loadStatus = computed(() => userStore.loadStatus)

    // 获取权限信息
    // useAuthentication()

    return {
      resolveLayout,
      catchComponents,
      loadStatus,
    }
  },
}
</script>
<style>
@import './assets/font/font.css';
#app {
  font-family: 'Daimler-CS';
  font-weight: 400;
}
</style>
